export default __webpack_public_path__ + "static/media/logo_ahlsell.18d768da.svg";